import { IShouldShowCateringMessage } from './types';

export const shouldShowCateringMessage = ({
  offers,
  loading,
  isCatering,
}: IShouldShowCateringMessage) => offers.length === 0 && !loading && isCatering;
